/* istanbul ignore file */
import { RequestOptions } from 'bernie-graphql';
import { SerializedData } from 'bernie-core';
import { AnalyticsStore } from 'bernie-plugin-mobx';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';

import { BaseBexApiStore } from './bex-api-store';
import analyticsWrapper from 'utility/analytics-wrapper';
import { clientInfoHeader } from 'utility/header-utils';
import { FlightsShoppingPwaFlightServicingResults } from '__generated__/api/';

export class FlightServicingStore extends BaseBexApiStore {
  public hydrate(data: SerializedData): void {
    super.hydrate(data);

    this.bexApiSource.clientConfigs.bexApiUrl = '/graphql';
  }

  public fetchResults(
    servicingVariables: FlightsShoppingPwaFlightServicingResults.Variables,
    options: RequestOptions,
    analytics: AnalyticsStore
  ): Promise<FlightsShoppingPwaFlightServicingResults.FlightsServicing> {
    const { appName, region } = this.bexApiSource.clientConfigs;
    this.bexApiSource.headers = clientInfoHeader(this.bexApiSource.headers, appName, region);

    return this.bexApiSource.operations
      .flightsShoppingPwaFlightServicingResults(servicingVariables, options)
      .then(response => {
        const { flightsServicing } = response?.data ?? {};

        analyticsWrapper.publishAnalyticsPayload(response, analytics);

        return {
          ...flightsServicing
        };
      })
      .catch(error => {
        this.logger.logEvent(new SystemEvent(SystemEventLevel.CRITICAL, 'SERVICING_FETCH'), error);

        return null;
      });
  }
}

FlightServicingStore.DEFAULTS = {};
